import {
    type OpenApiGetDiscountsResponseSuccess,
    type OpenApiGetDiscountsSearchParams,
    type OpenApiSchemaDiscount,
} from '#shared/api/schema';
import { createPaginateDataGridProvider } from '#shared/components/grid';
import { discountApi, discountGridTagInvalidator } from '../../api/api';

export const useDiscountDataGridProvider = createPaginateDataGridProvider<
    OpenApiSchemaDiscount,
    OpenApiGetDiscountsSearchParams,
    OpenApiGetDiscountsResponseSuccess,
    'Discount'
>({
    getPageNumber: (params) => params.page ?? 1,
    getPerPage: (params) => params.per_page ?? 25,
    getTotal: (result) => result.total_count,
    getRows: (result) =>
        result.discounts.map((item, index) => {
            return { id: `${item.id}/${index}`, attributes: item };
        }),
    getItemFromRow: (row) => row.attributes,
    endpoint: discountApi.endpoints.getList,
    invalidateTagHelper: discountGridTagInvalidator,
});
